var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"items":_vm.breadcrumbItems,"hasBreadcrumb":"","hasBackButton":""}}),_c('form',[_c('b-card',{staticClass:"mc-card__setting"},[_c('b-tabs',{attrs:{"content-class":"p-3 text-muted","nav-wrapper-class":"mc-tab"}},[_c('GroupList')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }